import { getWhereConditionals } from 'global/firestoreData/helpers/getRefConditionals';
import React, { useCallback, useContext, useState } from 'react'
import { useAppUserAccess } from './useAppUserAccess';
import { PageDataContext } from '../PageDataContext';
import { ParentContext } from '../ParentContext';
import { postDataConstraits } from '../contextHelpers/postDataConstraits';
import _ from 'lodash'
import { _showAppLogs } from '../LogContext';

const _viewsPaths = {
  viewViewItem: 'currentSettings_state.gvviSettings.aps_views.'
}
export const useDataConditionals = ({ dataInit_state }) => {

  const { viewItem, uivi } = dataInit_state ?? {}

  const appUserAccess = useAppUserAccess()

  const parentContexts = useContext(ParentContext)
  const { states, handlers } = parentContexts ?? {}
  const { paps_state } = states ?? {}
  const { log_handlers } = handlers
  const { view, viewKey } = paps_state ?? {}

  const pageDataContext = useContext(PageDataContext);

  const { aps_global } = _.get(states, 'currentSettings_state.gvviSettings', {});
  const { alphabetValue } = _.get(states, 'data_state', {});
  const { dataOverrideOn } = _.get(states, 'appSettings_state', {});
  const { hideInactiveItems } = _.get(aps_global, 'dataOptions', {});
  const { pathViews, nonLandingView, viewKey: dataCollectionItemKey } = _.get(states, 'paps_state', {});
  const { pageData_state } = pageDataContext ?? {}
  const { currentPageData } = pageData_state ?? {}

  const viewName = viewKey ? view : `${view}_list`

  const getFilterProps = (vvi, dci) => {
    const vi = _.get(states, `${_viewsPaths.viewViewItem}${viewName}.viewItems.${vvi}`, {});
    // console.group('udc', view, vvi)
    // console.log('vi', vi)
    // console.groupEnd()
    return {
      restrictions: {
        dataOverrideOn,
        hideInactiveItems_do: hideInactiveItems
      },
      alphabetValue,
      appUserAccess,
      currentPageData,
      nonLandingView,
      order: null,
      pathViews,
      searchingValue: null,
      sortProp: viewItem?.display?.sortProp,
      trueUivi: vvi,
      viewItem: vi,
      viewKey: dci,
      whereOpts: { priors: [], posts: [], dataKeys: [], _priors: [], _posts: [], _priorz: [], _postz: [], },
    }
  }

  const getFilteredData = useCallback((data, callback, dataState) => {
    const { viewItem: viewItem_ds, uivi: uivi_ds } = dataState ?? {}
    let dataFilterProps = {}
    if (viewItem_ds) {
      dataFilterProps = getFilterProps(uivi_ds, dataCollectionItemKey)
    } else {
      dataFilterProps = getFilterProps(uivi, dataCollectionItemKey)
    }
    const { whereOpts } = getWhereConditionals({ ...dataFilterProps }, origin)
    return filterData(dataState || dataInit_state, data, whereOpts, callback, log_handlers)
  }, []);

  return {
    // getDataConditionals,
    getFilteredData,
  }

}

const filterData = (dataInit_state, data, whereOpts, callback, log_handlers) => {

  const { viewItem } = dataInit_state ?? {}
  const { dataSource } = viewItem ?? {}
  const { dataCollectionName } = dataSource ?? {}

  const _data = _.cloneDeep(data)

  let { postData: _postData } = postDataConstraits(whereOpts, _data, viewItem?.key)

  if (_.size(_data) !== _.size(_postData)) {
    _showAppLogs.itemData && log_handlers.addLog(`🧩💾 Filtered collection data(${dataCollectionName}):size(${_.size(_postData)}/${_.size(_data)})`, whereOpts);
  } else {
    _showAppLogs.itemData && log_handlers.addLog(`🧩💾 No Filter (${dataCollectionName})`)
  }
  callback(_postData)
}